import React from 'react';

import { makeStyles, useTheme } from '@material-ui/core/styles';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles((theme) => ({
  authorpos: {
    color: theme.palette.primary.highlight,
  },
}));

export default function MetagenicsArticleCardBody(props) {
  const classes = useStyles();
  const theme = useTheme();
  const AuthorBlock = (author, authorpos, authorimg) => {
    if (author != null || authorpos != null || authorimg != null) {
      return (
        <>
          <Box height={32} width={32} mr={1}>
            <img
              src={props.authorimg}
              alt={'written by ' + props.author}
              style={{
                clipPath: 'circle(16px at center)',
                top: theme.spacing(-1),
                width: '100%',
                height: 'auto',
              }}
            />
          </Box>
          <Box display='flex' flexDirection='column'>
            <Typography variant='caption'>{props.author}</Typography>
            <Typography variant='caption' className={classes.authorpos}>
              <small>{props.authorpos}</small>
            </Typography>
          </Box>
        </>
      );
    } else {
      return null;
    }
  };
  return (
    <CardContent style={{ padding: '8px 16px' }}>
      <Box>
        <Box pb={1}>
          {/* <Box
            display='flex'
            justifyContent='space-between'
            alignItems='center'
            pb={0.5}
            height={31}
          >
            <Typography variant='overline' className='line-clamp-1'>
              {props.subtitle}
            </Typography>
          </Box> */}
          <Box height={66} display='flex' alignItems='center' pt={0.5}>
            <Typography variant='h6' className='line-clamp-3'>
              {props.title}
            </Typography>
          </Box>
        </Box>
        <Box display='flex' alignItems='center' height={48}>
          {AuthorBlock(props.author, props.authorpos, props.authorimg)}
        </Box>
      </Box>
    </CardContent>
  );
}
